import { skipToken, useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/**
 * One supplier's translations for the remap picker on a task page. Blank
 * query lists the most recently updated translations.
 */
export function useSearchSupplierTranslations(input: {
  supplierId: string | null;
  query: string;
  limit?: number;
}) {
  const { supplierId, query, limit = 20 } = input;
  return useQuery({
    ...orpc.accountsPayable.supplierDocumentLines.searchTranslations.queryOptions(
      {
        input: supplierId ? { supplierId, query, limit } : skipToken,
      },
    ),
    enabled: Boolean(supplierId),
    placeholderData: (previous) => previous,
  });
}
